var map = {
	"./2020-01-21 best-of-both-worlds.md": 541,
	"./2020-01-30 smart-questions.md": 542,
	"./2020-02-13 coding-standards.md": 543,
	"./2020-05-15 to-a-new-start.md": 544,
	"./2020-05-18 internbit-resources.md": 545,
	"./2020-05-22 radgrad.md": 546,
	"./2020-06-04 x-ray-evaluation.md": 547,
	"./2020-06-05 pair-programming.md": 548,
	"./2020-10-24 recommendation-systems.md": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;